import { useCallback, useEffect, useState } from 'react'
import { Col, Form, Modal, Row } from 'react-bootstrap'
import { CheckCircleFill, XCircleFill } from 'react-bootstrap-icons'
import { CustomButton } from '../../../../components/CustomButton'
import { CustomSpinner } from '../../../../components/CustomSpinner'
import WmsAddressService from '../../../../services/database/WmsAddressService'
import { sendErrorApiMessage } from '../../../../utils/sendErrorApiMessage'

export default function ModalEndereco({
  title,
  isOpen,
  onClose,
  loadAddresses,
  onSubmit,
  isRequestLoading,
  codendereco,
}) {
  const [data, setData] = useState({
    codendereco: '',
    deposito: '',
    rua: '',
    predio: '',
    nivel: '',
    apto: '',
    tipoender: 'AP',
    situacao: 'L',
    ativo: 'S',
    bloqueio: 'N',
    status: 'S',
    codfabricante: '',
    gerar: 'todos',
  })

  const [emMassa, setEmMassa] = useState(false)

  const [ruaMassa, setRuaMassa] = useState({
    from: '',
    to: '',
  })
  const [predioMassa, setPredioMassa] = useState({
    from: '',
    to: '',
  })
  const [nivelMassa, setNivelMassa] = useState({
    from: '',
    to: '',
  })
  const [aptoMassa, setAptoMassa] = useState({
    from: '',
    to: '',
  })

  const [isAddressLoading, setIsAddressLoading] = useState(false)

  const isFormAddressDisabled = Boolean(
    codendereco
      ? false
      : !emMassa
        ? !data.deposito ||
          !data.rua ||
          !data.predio ||
          !data.nivel ||
          !data.apto
        : !ruaMassa.from ||
          !ruaMassa.to ||
          !predioMassa.from ||
          !predioMassa.to ||
          !nivelMassa.from ||
          !nivelMassa.to ||
          !aptoMassa.from ||
          !aptoMassa.to,
  )

  function handleChange(e) {
    const { name, value } = e.target

    setData((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  const getAddressByCodendereco = useCallback(async (codAddress) => {
    try {
      setIsAddressLoading(true)

      const address = await WmsAddressService.getByCodendereco(codAddress)

      setData({
        ...address,
      })
    } catch (err) {
      sendErrorApiMessage(
        err,
        'Não foi possível carregar os dados do endereço!',
      )
    } finally {
      setIsAddressLoading(false)
    }
  }, [])

  useEffect(() => {
    if (codendereco) {
      getAddressByCodendereco(codendereco)
    }
  }, [codendereco, getAddressByCodendereco])

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      dialogClassName="custom-modalzpl"
    >
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div
          className="p-4"
          style={{
            overflowY: 'hidden',
          }}
        >
          {isAddressLoading ? (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 15,
              }}
            >
              <CustomSpinner size={60} />
              <h3
                style={{
                  margin: 0,
                }}
              >
                Carregando endereço...
              </h3>
            </div>
          ) : (
            <div>
              {!codendereco && (
                <Form.Check
                  label="Em Massa"
                  checked={emMassa}
                  onChange={() => setEmMassa((prevState) => !prevState)}
                  style={{
                    marginBottom: 20,
                  }}
                />
              )}

              <Form
                onSubmit={(e) => {
                  e.preventDefault()

                  const dataFormatted = {
                    ...data,
                    emMassa,
                    ruaMassa,
                    predioMassa,
                    nivelMassa,
                    aptoMassa,
                  }

                  onSubmit(dataFormatted).finally(() => {
                    loadAddresses()
                    onClose()
                  })
                }}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <main
                  style={{
                    flex: 1,
                  }}
                >
                  <Row className="mb-3">
                    <Col>
                      <Form.Label>Depósito</Form.Label>
                      <Form.Control
                        name="deposito"
                        value={data.deposito}
                        onChange={handleChange}
                      />
                    </Col>

                    <Col>
                      <Form.Label>Rua</Form.Label>
                      {emMassa ? (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            gap: 10,
                          }}
                        >
                          <Form.Control
                            value={ruaMassa.from}
                            onChange={(e) =>
                              setRuaMassa((prevState) => ({
                                ...prevState,
                                from: e.target.value,
                              }))
                            }
                          />

                          <Form.Control
                            value={ruaMassa.to}
                            onChange={(e) =>
                              setRuaMassa((prevState) => ({
                                ...prevState,
                                to: e.target.value,
                              }))
                            }
                          />
                        </div>
                      ) : (
                        <Form.Control
                          name="rua"
                          value={data.rua}
                          onChange={handleChange}
                        />
                      )}
                    </Col>

                    <Col>
                      <Form.Label>Prédio</Form.Label>

                      {emMassa ? (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            gap: 10,
                          }}
                        >
                          <Form.Control
                            value={predioMassa.from}
                            onChange={(e) =>
                              setPredioMassa((prevState) => ({
                                ...prevState,
                                from: e.target.value,
                              }))
                            }
                          />

                          <Form.Control
                            value={predioMassa.to}
                            onChange={(e) =>
                              setPredioMassa((prevState) => ({
                                ...prevState,
                                to: e.target.value,
                              }))
                            }
                          />
                        </div>
                      ) : (
                        <Form.Control
                          name="predio"
                          value={data.predio}
                          onChange={handleChange}
                        />
                      )}
                    </Col>

                    <Col>
                      <Form.Label>Nível</Form.Label>

                      {emMassa ? (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            gap: 10,
                          }}
                        >
                          <Form.Control
                            value={nivelMassa.from}
                            onChange={(e) =>
                              setNivelMassa((prevState) => ({
                                ...prevState,
                                from: e.target.value,
                              }))
                            }
                          />

                          <Form.Control
                            value={nivelMassa.to}
                            onChange={(e) =>
                              setNivelMassa((prevState) => ({
                                ...prevState,
                                to: e.target.value,
                              }))
                            }
                          />
                        </div>
                      ) : (
                        <Form.Control
                          name="nivel"
                          value={data.nivel}
                          onChange={handleChange}
                        />
                      )}
                    </Col>

                    <Col>
                      <Form.Label>Apartamento</Form.Label>

                      {emMassa ? (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            gap: 10,
                          }}
                        >
                          <Form.Control
                            value={aptoMassa.from}
                            onChange={(e) =>
                              setAptoMassa((prevState) => ({
                                ...prevState,
                                from: e.target.value,
                              }))
                            }
                          />

                          <Form.Control
                            value={aptoMassa.to}
                            onChange={(e) =>
                              setAptoMassa((prevState) => ({
                                ...prevState,
                                to: e.target.value,
                              }))
                            }
                          />
                        </div>
                      ) : (
                        <Form.Control
                          name="apto"
                          value={data.apto}
                          onChange={handleChange}
                        />
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md={2}>
                      <Form.Label>Tipo End.</Form.Label>
                      <Form.Select
                        name="tipoender"
                        value={data.tipoender}
                        onChange={handleChange}
                      >
                        <option value="AP">AP</option>
                        <option value="AE">AE</option>
                      </Form.Select>
                    </Col>

                    <Col md={3}>
                      <Form.Label>Situação</Form.Label>
                      <Form.Select
                        name="situacao"
                        value={data.situacao}
                        onChange={handleChange}
                      >
                        <option value="L">Liberado</option>
                        <option value="B">Bloqueado</option>
                      </Form.Select>
                    </Col>

                    <Col md={2}>
                      <Form.Label>Ativo</Form.Label>
                      <Form.Select
                        name="ativo"
                        value={data.ativo}
                        onChange={handleChange}
                      >
                        <option value="S">Sim</option>
                        <option value="N">Não</option>
                      </Form.Select>
                    </Col>

                    <Col md={2}>
                      <Form.Label>Bloqueio</Form.Label>
                      <Form.Select
                        name="bloqueio"
                        value={data.bloqueio}
                        onChange={handleChange}
                      >
                        <option value="S">Sim</option>
                        <option value="N">Não</option>
                      </Form.Select>
                    </Col>

                    <Col>
                      <Form.Label>Status</Form.Label>
                      <Form.Select
                        name="status"
                        value={data.status}
                        onChange={handleChange}
                      >
                        <option value="S">Sim</option>
                        <option value="N">Não</option>
                      </Form.Select>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col xs={3}>
                      <Form.Label>Cód. Fabricante</Form.Label>
                      <Form.Control
                        name="codfabricante"
                        value={data.codfabricante}
                        onChange={handleChange}
                      />
                    </Col>

                    {!codendereco && emMassa && (
                      <Col xs={3}>
                        <Form.Label>Gerar</Form.Label>
                        <Form.Select
                          name="gerar"
                          value={data.gerar}
                          onChange={handleChange}
                        >
                          <option value="todos">Todos</option>
                          <option value="pares">Pares</option>
                          <option value="impares">Ímpares</option>
                        </Form.Select>
                      </Col>
                    )}
                  </Row>
                </main>

                <Modal.Footer>
                  <CustomButton
                    type="submit"
                    title="Salvar"
                    color="#229954"
                    isLoading={isRequestLoading}
                    isDisabled={isFormAddressDisabled || isRequestLoading}
                    isLoadingText="Salvando..."
                  >
                    <CheckCircleFill />
                  </CustomButton>

                  <CustomButton
                    title="Cancelar"
                    color="#b03a2e"
                    isDisabled={isRequestLoading}
                    onClick={onClose}
                  >
                    <XCircleFill />
                  </CustomButton>
                </Modal.Footer>
              </Form>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  )
}
